import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import NewsBrowser from '@/pages/news/components/NewsBrowser';

export default function NewsPage() {
  useSeo({
    title: '影视资讯 - 91大神影视平台',
    description:
      '91大神影视资讯频道提供最新电影、剧集与综艺的上线消息、深度影评解读、行业观察与活动公告，帮助你及时了解影视动态。',
    keywords: '91大神, 影视资讯, 影评解读, 行业观察, 影视新闻, 新片消息',
    canonicalPath: '/news',
  });

  return (
    <SiteLayout>
      <NewsBrowser />
    </SiteLayout>
  );
}